export const globalRef = {
    positionList: {},
    dicPnl: {}
}